import { ERROR_STEPS } from './wizardSteps';
import type { WizardAction, WizardState } from './wizardTypes';
import { WizardActionType } from './wizardTypes';

export function reducer(state: WizardState, action: WizardAction): WizardState {
  switch (action.type) {
    case WizardActionType.GOTO_STEP: {
      return {
        ...state,
        currentStep: state.activeSteps.find((step) => step.id === action.stepId) ?? state.activeSteps[0],
      };
    }
    case WizardActionType.GOTO_ERROR_STEP: {
      return {
        ...state,
        currentStep: ERROR_STEPS[action.stepId],
      };
    }
    case WizardActionType.GOTO_NEXT_STEP: {
      const currentStepIndex = action.activeSteps.findIndex((step) => step.id === state.currentStep?.id);
      const nextStepIndex = Math.min(currentStepIndex + 1, action.activeSteps.length - 1);
      return {
        ...state,
        currentStep: action.activeSteps[nextStepIndex],
      };
    }
    case WizardActionType.GOTO_PREVIOUS_STEP: {
      const currentStepIndex = action.activeSteps.findIndex((step) => step.id === state.currentStep?.id);
      const previousStepIndex = Math.max(currentStepIndex - 1, 0);
      return {
        ...state,
        currentStep: action.activeSteps[previousStepIndex],
      };
    }
    default:
      return state;
  }
}
